import { InfoWindow, Marker } from '@react-google-maps/api';
import {memo,useState,useCallback, useEffect} from 'react'
import { useTheme } from '@mui/material';
import KmzService from '../../services/kmz.service';

const infoWindowStyles = `
.gm-style-iw-c {
    padding: 0 !important;
    border-radius: 10px !important;
    overflow: visible !important;
    box-shadow: 0 4px 20px rgba(0,0,0,0.15) !important;
}
.gm-style-iw-d {
    overflow: hidden !important;
    max-height: none !important;
}
.gm-style-iw-tc::after {
    background: #fff !important;
}
.gm-ui-hover-effect {
    top: 2px !important;
    right: 2px !important;
}
`;

const infoWindowDarkStyles = `
.gm-style-iw-c {
    padding: 0 !important;
    border-radius: 10px !important;
    overflow: visible !important;
    background: #1F2A40 !important;
    box-shadow: 0 4px 20px rgba(0,0,0,0.5) !important;
    border: 1px solid #3d4a62 !important;
}
.gm-style-iw-d {
    overflow: hidden !important;
    max-height: none !important;
}
.gm-style-iw-tc::after {
    background: #1F2A40 !important;
}
.gm-ui-hover-effect > span {
    background-color: #b0bec5 !important;
}
.gm-ui-hover-effect {
    top: 2px !important;
    right: 2px !important;
}
`;

function MarkerFibraNaps({
    coordenadas,
    item,
    isInCoverage = false,
    origenCoord = null,
    ...defaultProps
}) {
    const theme = useTheme();
    const isDarkMode = theme.palette.mode === 'dark';
    const [isVisible, setIsVisible] = useState(false);
    const [distancia, setDistancia] = useState(null);
    const [loadingDistancia, setLoadingDistancia] = useState(false);
    const [colorIcon, setcolorIcon] = useState('/img/nap-fibra-optica.png')
    useEffect(() => {
        setDistancia(null);
    }, [origenCoord?.lat, origenCoord?.lng]);
    useEffect(() => {
        switch (item?.estadoColor || item?.estado) {
            case 'VERDE':
            case 'DISPONIBLE':
            case 'DISPONIBLES':
                setcolorIcon('/img/nap-verde.png')
                break;
            case 'AMARILLO':
                setcolorIcon('/img/nap-amarillo.png')
                break;
            case 'PROYECTADA':
            case 'PROYECTADAS':
                setcolorIcon('/img/nap-gris.png')
                break;
            case 'NARANJA':
                setcolorIcon('/img/nap-naranja.png')
                break;
            case 'NO DISPONIBLE':
            case 'NO DISPONIBLES':
            case 'ROJO':
                setcolorIcon('/img/nap-rojo.png')
                break;
            default:
                setcolorIcon('/img/nap-fibra-optica.png')
                break;
        }
    }, [item])
    
    return (
        <Marker
            {...defaultProps}
            position={coordenadas}
            onClick={()=>setIsVisible(!isVisible)}
            icon={{
                url: colorIcon,
                scaledSize: {
                    width: isInCoverage ? 65 : 50,
                    height: isInCoverage ? 65 : 50,
                }
            }}
            animation={isInCoverage ? window.google?.maps?.Animation?.BOUNCE : null}
            zIndex={isInCoverage ? 1000 : 1}
        >
            { isVisible && (
                <>
                    <style>{isDarkMode ? infoWindowDarkStyles : infoWindowStyles}</style>
                    <InfoWindow
                        className="card"
                        position={coordenadas}
                        onCloseClick={()=>{setIsVisible(!isVisible)}}
                    >
                        <div style={{
                            backgroundColor: isDarkMode ? '#1F2A40' : '#fff',
                            color: isDarkMode ? '#e0e0e0' : '#000',
                            padding: '14px 16px',
                            borderRadius: '10px',
                            minWidth: '180px',
                            fontFamily: "'Segoe UI', Roboto, sans-serif",
                        }}>
                            {isInCoverage ? (
                                <div style={{
                                    background: isDarkMode 
                                        ? 'linear-gradient(135deg, #2e7d32, #43a047)' 
                                        : 'linear-gradient(135deg, #43a047, #66bb6a)',
                                    color: '#fff',
                                    padding: '5px 10px',
                                    borderRadius: '6px',
                                    fontWeight: 600,
                                    fontSize: '11px',
                                    textAlign: 'center',
                                    marginBottom: '10px',
                                    letterSpacing: '0.5px',
                                }}>
                                    ✓ EN COBERTURA
                                </div>
                            ) : (
                                <div style={{
                                    background: isDarkMode 
                                        ? 'linear-gradient(135deg, #b71c1c, #e53935)' 
                                        : 'linear-gradient(135deg, #e53935, #ef5350)',
                                    color: '#fff',
                                    padding: '5px 10px',
                                    borderRadius: '6px',
                                    fontWeight: 600,
                                    fontSize: '11px',
                                    textAlign: 'center',
                                    marginBottom: '10px',
                                    letterSpacing: '0.5px',
                                }}>
                                    ✗ FUERA DE COBERTURA
                                </div>
                            )}
                            <div style={{
                                fontSize: '15px',
                                fontWeight: 700,
                                color: isDarkMode ? '#e0e0e0' : '#1a1a2e',
                                textAlign: 'center',
                                marginBottom: '8px',
                                paddingBottom: '8px',
                                borderBottom: `1px solid ${isDarkMode ? '#3d4a62' : '#e0e0e0'}`,
                            }}>
                                {item?.nombre_fnap || item?.nombre}
                            </div>
                            <div style={{
                                display: 'flex',
                                flexDirection: 'column',
                                gap: '4px',
                            }}>
                                <div style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    fontSize: '12px',
                                }}>
                                    <span style={{color: isDarkMode ? '#8899a6' : '#666', fontWeight: 500}}>Distancia</span>
                                    <span style={{color: isDarkMode ? '#e0e0e0' : '#1a1a2e', fontWeight: 600}}>
                                        {isInCoverage?.distanciaReal || item?.distanciaReal || item?.distanciaMts || '-'} Mts
                                    </span>
                                </div>
                                <div style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    fontSize: '12px',
                                }}>
                                    <span style={{color: isDarkMode ? '#8899a6' : '#666', fontWeight: 500}}>Ocupados</span>
                                    <span style={{
                                        color: isDarkMode ? '#e0e0e0' : '#1a1a2e',
                                        fontWeight: 600,
                                        backgroundColor: isDarkMode ? '#2d3a52' : '#f0f0f0',
                                        padding: '2px 8px',
                                        borderRadius: '4px',
                                        fontSize: '11px',
                                    }}>
                                        {`${item?.usados}/${item?.puertos}`}
                                    </span>
                                </div>
                                {!isInCoverage && origenCoord && (
                                    <div style={{
                                        marginTop: '8px',
                                        paddingTop: '8px',
                                        borderTop: `1px solid ${isDarkMode ? '#3d4a62' : '#e0e0e0'}`,
                                    }}>
                                        {distancia !== null ? (
                                            <div style={{
                                                textAlign: 'center',
                                                display: 'flex',
                                                flexDirection: 'column',
                                                gap: '4px',
                                                alignItems: 'center',
                                            }}>
                                                <span style={{
                                                    fontSize: '14px',
                                                    fontWeight: 700,
                                                    color: isDarkMode ? '#90caf9' : '#1565c0',
                                                }}>
                                                    {distancia.distanciaTexto || `${distancia.distancia} Mts`}
                                                </span>
                                                {distancia.duracionTexto && (
                                                    <span style={{
                                                        fontSize: '11px',
                                                        fontWeight: 500,
                                                        color: isDarkMode ? '#a0aec0' : '#616161',
                                                    }}>
                                                        🚶 {distancia.duracionTexto}
                                                    </span>
                                                )}
                                                {distancia.aproximado && (
                                                    <span style={{
                                                        fontSize: '10px',
                                                        fontStyle: 'italic',
                                                        color: isDarkMode ? '#f9a825' : '#e65100',
                                                    }}>
                                                        (línea recta aprox.)
                                                    </span>
                                                )}
                                            </div>
                                        ) : (
                                            <button
                                                onClick={async (e) => {
                                                    e.stopPropagation();
                                                    setLoadingDistancia(true);
                                                    try {
                                                        const latNap = item?.latitud_fnap || item?.latitud;
                                                        const lngNap = item?.longitud_fnap || item?.longitud;
                                                        const resp = await KmzService.calcularDistanciaNap({
                                                            latOrigen: origenCoord.lat,
                                                            lngOrigen: origenCoord.lng,
                                                            latNap,
                                                            lngNap,
                                                        });
                                                        setDistancia(resp);
                                                    } catch (err) {
                                                        console.log('Error calcular distancia:', err);
                                                    } finally {
                                                        setLoadingDistancia(false);
                                                    }
                                                }}
                                                disabled={loadingDistancia}
                                                style={{
                                                    width: '100%',
                                                    padding: '6px 12px',
                                                    border: 'none',
                                                    borderRadius: '6px',
                                                    cursor: loadingDistancia ? 'wait' : 'pointer',
                                                    fontWeight: 600,
                                                    fontSize: '11px',
                                                    letterSpacing: '0.3px',
                                                    color: '#fff',
                                                    background: isDarkMode
                                                        ? 'linear-gradient(135deg, #1565c0, #1e88e5)'
                                                        : 'linear-gradient(135deg, #1e88e5, #42a5f5)',
                                                    transition: 'opacity 0.2s',
                                                    opacity: loadingDistancia ? 0.7 : 1,
                                                }}
                                            >
                                                {loadingDistancia ? 'Calculando...' : '📏 Calcular distancia'}
                                            </button>
                                        )}
                                    </div>
                                )}
                            </div>
                        </div>
                    </InfoWindow>
                </>
            )}
        </Marker>
    );
}

export default memo(MarkerFibraNaps);
